const defaults = {
    stringifier: JSON.stringify,
    fallbackMsg: "Could not stringify the given input.",
};
/**
 * Stringify any given input withouth throwing an error.
 *
 * Order of proceeding:
 *  - try to call .toString() on it
 *  - try to parse it with a stringifier (JSON.stingify by default)
 *  - return a fallback string.
 */
export const stringifyAnything = (input, options) => {
    const fullOptions = {
        ...defaults,
        options,
    };
    try {
        return input.toString();
    }
    catch (err) {
        /*
         * While using try/catch for control flow is not ideal,
         *  I didn't find a better way to check for an existing toString().
         */
    }
    try {
        return fullOptions.stringifier(input);
    }
    catch (err) {
        return fullOptions.fallbackMsg;
    }
};
//# sourceMappingURL=stringifyAnything.js.map